<template>
  <CrudList
    title="Trakers"
    storeName="Trakers"
    slot-scope="{ item }"
    sortable
    canSearch
    label-show="Ver"
    :canAdd="false"
    :canEdit="false"
    :canDelete="true"
    :canShow="true"
    next-link="/admin/coin_purchases"
    :breadcrumbs="[
      {
        text: 'Reservas y estadías',
        disabled: false,
        href: '/admin/trakers'
      },
      {
        text: 'Estadias por spot',
        disabled: false,
        href: '#'
      },
    ]"
  >

  <template v-slot:car="{ item }">
    <v-row align="center" justify="center">
      <v-col cols="12">
        <p>{{ item.driver && item.driver.patent ? item.driver.patent: '' }}</p>
      </v-col>
    </v-row>
  </template>
  <template v-slot:driver="{ item }">
    <v-row align="center" justify="center">
      <v-col cols="12">
        <p>{{ item.driver && item.driver.user ? `${item.driver.user.name || ''} ${item.driver.user.last_name || ''}`: '' }}</p>
      </v-col>
    </v-row>
  </template>

  <template v-slot:spot="{ item }">
    <v-row :key="item.post_id">
      {{item.spot && item.spot.alias_id ? item.spot.alias_id : '' }}
      {{item.spot && item.spot.address ? item.spot.address : '' }}
      {{item.spot && item.spot.unit ? item.spot.unit : '' }}
      ({{item.host ? `${item.host.name || ''} ${item.host.last_name || ''}` : ''}})
    </v-row>  
  </template>

  <template v-slot:host="{ item }">
    <v-row align="center" justify="center">
      <v-col cols="12">
        <p>{{ item.host && item.host ? `${item.host.name || ''} ${item.host.last_name || ''}`: '' }}</p>
      </v-col>
    </v-row>
  </template>

  </CrudList>
</template>

<script>
import { mapState } from "vuex";
import DeleteConfirm from "@/components/Crud/Modals/Confirm";
import CrudList from "@/components/Crud/CrudList";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  components: { CrudList },
  mixins: [CrudFormMixin],
  components: { CrudList, DeleteConfirm },
  computed: {
    ...mapState({
      options: (state) => state.Trakers.options,
    }),
  },
  created() {
  },
  data() {
    return {
      storeName: "Trakers",
      labelDelete: "Eliminar",
      titleDeleted: "Eliminar el registro",
      descriptionDeleted: "¿Quieres eliminar este registro?",
      labelModalConfirm: "Confirmar",
      labelModalCancel: "Cancelar",
      selected_item: "",
      confirmDelete: false,
    };
  },
  methods: {
    deleteItem(item) {
      this.selected_item = item;
      this.confirmDelete = true;
    },
    hideConfirmDelete() {
      this.confirmDelete = false;
    },
    async confirmDeleteItem() {
      const self = this;
      self.$store
        .dispatch(this.storeName + "/delete", this.selected_item)
        .then(() => {
          self.$store.dispatch(this.storeName + "/getList", this.options);
          self.confirmDelete = false;
        });
    },
  },
};
</script>
